import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { MultiRowCarouselState_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const CommissionDetailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    date: null,
    amt: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyRecord, i: 0}]);
  const [homogenous, setHomogenous] = useState<boolean>(true);

  function updateVal(val:any, field:string|string[]):void {
    let data = _.cloneDeep(props.rowData[props.field]) || {};
    if (!(Array.isArray(field))){
       _.set(data, field, val);
    } else {
      if(items[field[0]][field[1]] === val) return
      items[field[0]][field[1]] = val
      if (field[1] === 'date'){
        let dateModeCheck = checkDateSet(val, items)
        setHomogenous(dateModeCheck.homogenous);
        _.set(data, 'dateMode', dateModeCheck.dateMode);
      }
    }
    if (!data['amtType']) data['amtType'] = props.defaults['commissionAmtType']
    if (!data['inflationNamedItemId'] && props.defaults['commissionInflation']) data['inflationNamedItemId'] = props.defaults['commissionInflation']['inflationNamedItemId']
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");
    _.set(data, 'items', strippedItems);
    if (data.state !== 'detailed') _.set(data, 'state', 'detailed');
    const clearInflation = ['% of Rent Paid', '# of Mos Rent'].includes(field == 'amtType' ? val : _.get(data, 'amtType'))
    if (clearInflation) _.set(data, 'inflationNamedItemId', null)

    delete data.amt
    props.persist(data, 'commissiondetail', props.rowData);
  }

  function updateItems(items:Item_t[]):void {
    let data = _.cloneDeep(props.rowData[props.field]);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");
    _.set(data, 'items', strippedItems);
    if (data.state !== 'detailed') _.set(data, 'state', 'detailed');

    delete data.amt
    props.persist(data, 'commissiondetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (_.get(props['rowData'][props.field], "state") !== 'detailed'){
      setItems([{...emptyRecord, i: 0}]);
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('multifamily', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s style={{marginBottom: 10}} className="carousel-single-row">
        <div>
          <label>Amt Type</label>
          <DropdownInput className="automated" data={props.rowData[props.field]} attrs={attrs} field="amtType" options={['Amt/Area', 'Amt/Unit', '% of Rent Paid', '# of Mos Rent']} persist={updateVal} default={props.defaults['commissionAmtType']} />
        </div>
        <div>
          <label>Inflation</label>
          <NamedItemInput className="automated" data={props.rowData[props.field]} attrs={attrs} field="inflationNamedItemId" options={props.namedItems['inflation']} persist={updateVal} disabled={props.rowData[props.field] && (props.rowData[props.field]['amtType'] === '% of Rent Paid' || props.rowData[props.field]['amtType'] === '# of Mos Rent')} default={props.defaults['commissionInflation'] && props.defaults['commissionInflation']['inflationNamedItemId']} />
        </div>
      </SingleRowCarouselState_s>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Date</label> }
              <DateInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'date']} {...params} allowRelative withoutDays />
            </div>
            <div>
              { i === 0 && <label>Amt</label> }
              <NumberInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'amt']} {...params} readPrecision={2} writePrecision={2} />
            </div>
            <RowAddRemove emptyRecord={emptyRecord} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
      {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
    </div>
  )
}

export default CommissionDetailed
